import { useNavigate, useLocation } from 'react-router-dom'
import { useOperatorAuth } from '@hooks/useOperatorAuth'
import styles from './OperatorNavbar.module.css'

const ROLE_LABELS: Record<string, string> = {
  admin: 'Admin',
  backoffice: 'Backoffice',
  bo_ameconviene: 'Backoffice Ameconviene',
  operatore: 'Operatore',
  supervisor: 'Supervisor',
}

async function openProductManager() {
  try {
    const res = await fetch('/backend/api/v1/operator/product-manager-token', { credentials: 'include' })
    const data = await res.json()
    if (data.data?.token) {
      window.open('/product_manager/prodotti.php?auth_token=' + data.data.token, '_blank')
    }
  } catch (e) {
    console.error('Errore apertura Product Manager:', e)
  }
}

export function OperatorNavbar() {
  const navigate = useNavigate()
  const location = useLocation()
  const { operator: user, logout } = useOperatorAuth()

  const isBusiness = location.pathname.includes('/business')

  const handleLogout = () => {
    logout()
    navigate('/operatore/login')
  }

  const isActive = (path: string) => location.pathname === path

  if (!user) return null

  const isPraticheOnly = user.pratiche_only || user.role === 'bo_ameconviene'
  const showProductManager = user.role === 'backoffice' || user.role === 'admin'
  const roleClass = styles[`role_${user.role}`] || ''
  const basePath = isPraticheOnly ? '/operatore' : (isBusiness ? '/operatore/business' : '/operatore')

  return (
    <nav className={styles.navbar}>
      <div className={styles.navbarContainer}>
        <div
          className={styles.navbarBrand}
          onClick={() => navigate(`${basePath}/pratiche`)}
        >
          <div className={styles.logoContainer}>
            <img
              src="/assets/logo.webp"
              alt="Hera"
              className={styles.navbarLogo}
            />
          </div>
        </div>

        <div className={styles.navbarLinks}>
          {!isPraticheOnly && (
            <>
              <button
                type="button"
                className={`${styles.navbarLink} ${isActive('/operatore') ? styles.navbarLinkActive : ''}`}
                onClick={() => navigate('/operatore')}
              >
                <i className="bi bi-house-door" />
                <span className={styles.navbarLinkText}>Domestico</span>
              </button>

              <button
                type="button"
                className={`${styles.navbarLink} ${isActive('/operatore/business') ? styles.navbarLinkActive : ''}`}
                onClick={() => navigate('/operatore/business')}
              >
                <i className="bi bi-building" />
                <span className={styles.navbarLinkText}>Business</span>
              </button>

              <div className={styles.navbarDivider} />
            </>
          )}

          <button
            type="button"
            className={`${styles.navbarLink} ${isActive('/operatore/pratiche') || isActive('/operatore/business/pratiche') ? styles.navbarLinkActive : ''}`}
            onClick={() => navigate(`${basePath}/pratiche`)}
          >
            <i className="bi bi-list-ul" />
            <span className={styles.navbarLinkText}>Pratiche</span>
          </button>

          {showProductManager && (
            <button
              type="button"
              className={styles.navbarLink}
              onClick={openProductManager}
            >
              <i className="bi bi-box-seam" />
              <span className={styles.navbarLinkText}>Prodotti</span>
            </button>
          )}

          <div className={styles.navbarDivider} />

          <div className={styles.navbarUser}>
            <div className={styles.userInfo}>
              <span className={styles.userName}>
                {user.full_name || user.username}
              </span>
              <span className={`${styles.roleBadge} ${roleClass}`}>
                {ROLE_LABELS[user.role] || user.role}
              </span>
            </div>
          </div>

          <button
            type="button"
            className={styles.logoutBtn}
            onClick={handleLogout}
            title="Logout"
          >
            <i className="bi bi-box-arrow-right" />
            <span className={styles.navbarLinkText}>Esci</span>
          </button>
        </div>
      </div>
    </nav>
  )
}
